export default [
  {
    title: 'Countries',
    route: 'countries',
    icon: 'GlobeIcon',
  },
]

